<script>
  import {onMount} from 'svelte';
  import PasswordVerification from '@/modules/register/componets/PasswordVerification.svelte';

  export let showIcon = true;
  export let innerWidth = 1200;
  export let value = '';
  export let placeholder = '';
  export let placement = 'left';
  export let autocomplete = 'on';
  export let disabled = false;
  export let isError = false;
  export let autofocus = false;
  export let isShowPasswordTips = false;
  export let isPasswordTips = false;
  export let modalUI = false;
  export let isShowSpecialCharacters = 5;
  export let readonly = false;
  export {className as class};

  let className = '';
  let input = null;
  let revealed = true;

  onMount(() => {
    autofocus && setTimeout(() => input && input.focus(), 0);
  });

  function handleClickRevealToggle() {
    if (!input) {
      return;
    }
    input.type = input.type === 'password' ? 'text' : 'password';
    revealed = !revealed;
  }
</script>

<style>
  .light-gray {
    color: var(--T4);
  }
  .item {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    height: 48px;
  }
  .item.error {
    border: 1px solid #f66;
  }
  .item:focus-within,
  .item:hover {
    border: 1px solid #003fe6;
  }
  .ipt {
    border: none;
    height: 88%;
    outline: none;
  }
  .ipt::-webkit-input-placeholder {
    color: var(--T3);
  }
  input[disabled] {
    background: transparent;
  }
  .disabled {
    background: #efefef;
  }
  .disabled input.autofill:-webkit-autofill,
  .disabled input.autofill:-webkit-autofill:hover,
  .disabled input.autofill:-webkit-autofill:focus {
    box-shadow: 0 0 0 1000px #efefef inset;
  }
  .password {
    top: 0;
    right: 320px;
  }
  .left {
    top: 0;
    right: -10px;
    transform: translateX(100%);
  }
  .modal-wrap {
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .modal-hint {
    position: fixed;
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
    transform: translate(20px, -43px);
  }
  .modal-ui input::placeholder {
    color: #9fa3ab;
  }
</style>

<div class="item pr df aic ph16 {className}" class:modal-ui={modalUI} class:error={isError} class:disabled>
  {#if showIcon}
    <i class="ml4 iconfont f18 light-gray">&#xe644;</i>
  {/if}
  <input class="autofill ml4 ipt f1" type="password" {readonly} {autocomplete} {placeholder} {disabled} bind:value bind:this={input} on:keypress on:focus on:blur />
  <i class="iconfont f18 light-gray cp usn" on:click={handleClickRevealToggle}>{@html revealed ? '&#xe73f;' : '&#xe750;'}</i>
  {#if isShowPasswordTips && innerWidth >= 640}
    <div class:modal-wrap={modalUI}>
      <div class="password pa" class:modal-hint={modalUI} class:left={placement === 'left'}><PasswordVerification password={value} {isPasswordTips} {placement} {isShowSpecialCharacters} /></div>
    </div>
  {/if}
</div>
{#if isShowPasswordTips && innerWidth < 640}
  <div class="password"><PasswordVerification password={value} {isPasswordTips} {placement} {isShowSpecialCharacters} /></div>
{/if}
